export default "__VITE_ASSET__BVomX4Hf__"